export class LoadingSpinnerController {}
